import type { FaireProductEntity } from "../../entity_types/product";

export const p_4b3shbnbyy: FaireProductEntity = {
  token: "p_4b3shbnbyy",
  type: "product",
  name: "Ultimate Ointment, 10 oz.",
  brandToken: "b_cf402a0d",
  brandName: "Noodle & Boo, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/b49567af183aa22d998f2b04c60c9febb9dcdc371401ff6595214010ef69c286.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5efb16ed4986af9430ab74aaf045c85aa777934a4c2b30152992afe56d4b57ff.jpeg",
    "https://cdn.faire.com/fastly/c2ea28c18158832ac3a0b269b01f79b0d0c1021193855aeec1b454a039cdc333.jpeg",
    "https://cdn.faire.com/fastly/0739894cb4d4ee9ed124b2e4cf9781c029bda362343e660905d57607fa2c951e.jpeg",
    "https://cdn.faire.com/fastly/32274cd7ded90bba5e60b06ec60367b58a244968268d671bebf03e468630c349.jpeg",
    "https://cdn.faire.com/fastly/5ac139d78ab53c415ddc3e1fc26774c997b8896da8e44754b3f133866721b96a.jpeg",
    "https://cdn.faire.com/fastly/02e2de65937deebee7accf7829c30c715780eea7346864acea1e0b3d9df771db.png",
    "https://cdn.faire.com/fastly/b7ed65d53754cb6f06572b478e68578628c2879b70b4847915a1693d7153f3f6.png",
    "https://cdn.faire.com/fastly/353906d3f85baf2a6c410549b364550ee7138b5acdec8b45e34d43b1f06a8571.png",
    "https://cdn.faire.com/fastly/6722ab64190343da62c86ab9ee11ab7940e3bc2c64d18777d6ad84513b60486e.png",
  ],
  priceDollars: 13.51,
  description:
    "•    Awarded the Seal of Acceptance by the National Eczema Association\n•    Fragrance- and steroid-free formula helps soothe itching and discomfort\n•    Zinc oxide protects and supports the skin’s natural healing process\n•    Enriched with bisabolol and allantoin to help reduce redness and inflammation\n•    Developed for eczema flare-ups, cradle cap, cracked, ultra-dry, and chapped skin\n•    Perfect for parents seeking targeted relief when skin needs extra care\n\nOur Promise:\n•    Hypoallergenic\n•    Pediatrician-tested & Dermatologist-tested\n•    Cruelty-free and Non-toxic\n•    Made in USA\n•    Free from Parabens, Preservatives, Phthalates, and Dyes",
  tags: [],
  msrpDollars: 27.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:53.831Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
